export default __webpack_public_path__ + "static/media/encircledTick.d2f5f530.svg";